/* eslint-disable no-unused-vars */
import React from 'react';
import style from './existing.module.scss';
import { selectUsers, changeRole, deleteUser } from 'store/admin/adminSlice';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import map from 'lodash-es/map';
import AdminHeader from 'components/adminHeader/adminHeader';
import AdminList from 'components/adminList/adminList';
import ExistingItem from 'components/adminList/existingItem/existingItem';
import FakeExistingItem from 'components/adminList/existingItem/fakeExistingItem';
import WarningModal from 'components/modal/warningModal';
import { setGlobalModal } from 'store/transitionSlice';
import Sorting from 'components/sorting/sorting';
import { usersSortTypes } from 'store/types';

export default function Cabinet() {
  const dispatch = useAppDispatch();
  const users = useAppSelector(selectUsers);

  const items =
    users === null
      ? map(Array(10), (v, i) => <FakeExistingItem key={i}></FakeExistingItem>)
      : map(users, (u) => (
          <ExistingItem
            key={u._id}
            user={u}
            onChangeRole={(data) => {
              dispatch(
                setGlobalModal(
                  <WarningModal
                    onCancel={() => {
                      dispatch(setGlobalModal(null));
                    }}
                    onConfirmLoader={true}
                    onConfirm={async () => {
                      const result = await dispatch(changeRole(data));

                      if (result.meta.requestStatus === 'fulfilled') {
                        dispatch(setGlobalModal(null));
                      }
                    }}
                    mainText="Вы уверены что хотите изменить роль пользователя?"
                    detailedText="Пользоатель будет наделен всеми полномочиями в соотвествии с ролью"
                    buttonText="Изменить"
                  ></WarningModal>
                )
              );
            }}
            onDeleteUser={(data) => {
              dispatch(
                setGlobalModal(
                  <WarningModal
                    onCancel={() => {
                      dispatch(setGlobalModal(null));
                    }}
                    onConfirmLoader={true}
                    onConfirm={async () => {
                      const result = await dispatch(
                        deleteUser({ _id: data._id })
                      );

                      if (result.meta.requestStatus === 'fulfilled') {
                        dispatch(setGlobalModal(null));
                      }
                    }}
                    mainText="Вы уверены что хотите удалить пользователя?"
                    detailedText="Пользоатель будет безвозвратно удален"
                    buttonText="Удалить"
                  ></WarningModal>
                )
              );
            }}
          ></ExistingItem>
        ));

  return (
    <div className={style.container}>
      <AdminHeader
        entity={location.pathname.split('/').slice(-1)[0]}
      ></AdminHeader>
      <AdminList
        text={
          items.length
            ? 'Зарегистрированные пользователи'
            : 'Список зарегистрированных пользователей пуст'
        }
      >
        <div className={style.sorting}>
          <Sorting
            items={usersSortTypes}
            startURL={'/admin/existing?'}
          ></Sorting>
        </div>
        {items.length ? items : ''}
      </AdminList>
    </div>
  );
}
